import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueCookies from 'vue-cookies'

import Vuex from 'vuex'
Vue.use(Vuex)

import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

import "semantic-ui-css/semantic.min.css";
require ("semantic-ui-css/semantic.js");

import VModal from 'vue-js-modal'
Vue.use(VModal)

Vue.use(VueCookies)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
